import { motion, useInView } from "framer-motion";
import { useRef, useState, useEffect } from "react";
import { Quote } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TestimonialsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    axios.get(`${API}/testimonials`).then(res => setTestimonials(res.data)).catch(() => {});
  }, []);

  return (
    <section id="testimonials" className="py-24 md:py-32 px-6 md:px-12 bg-[#0A0A0A]" data-testid="testimonials-section" ref={ref}>
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="mb-16"
        >
          <p className="font-sans text-xs uppercase tracking-[0.3em] text-[#E8891C] mb-4">Témoignages</p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#F5F5F0] tracking-tight" data-testid="testimonials-title">
            Ce que nos clients <span className="italic">disent</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.7, delay: index * 0.15, ease: "easeOut" }}
              className="group bg-[#121212] border border-[#2A2A2A] p-8 md:p-10 hover:border-[#E8891C]/30 transition-colors duration-500"
              data-testid={`testimonial-card-${index}`}
            >
              <Quote size={28} className="text-[#E8891C]/30 mb-6" strokeWidth={1} />
              <p className="font-serif text-lg md:text-xl text-[#F5F5F0] leading-relaxed mb-8 italic">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 bg-[#2A2A2A] flex items-center justify-center">
                  <span className="font-serif text-sm text-[#E8891C]">{testimonial.author?.[0]}</span>
                </div>
                <div>
                  <p className="font-sans text-sm font-semibold text-[#F5F5F0]">{testimonial.author}</p>
                  <div className="flex gap-1 mt-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <span key={i} className="text-[#E8891C] text-xs">&#9733;</span>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
